import React from 'react'

import { ZariContext } from '_zari/context'
import { Table, Form } from '_zari/core'

import { EstadosEnvioAsientos } from 'constants/index'

import * as AsientoContableService from 'services/asientosContables.service'

const CheckboxCell = ({ row }) => {
  const __zariContext = React.useContext(ZariContext)

  const [checked, setChecked] = React.useState(row.estadoEnvio === EstadosEnvioAsientos.PENDIENTE_ENVIO)
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const onChange = React.useCallback(() => {
    setIsSubmitting(true)

    AsientoContableService.actualizarEstadoEnvioxId(row._id, {
      estadoEnvio: checked ? EstadosEnvioAsientos.SIN_ESTADO : EstadosEnvioAsientos.PENDIENTE_ENVIO
    })
      .then(() => {
        __zariContext.toast('success', 'Estado actualizado para asiento.')
        setChecked(prev => !prev)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        setIsSubmitting(false)
      })
  }, [__zariContext, row, checked])

  return (
    <Table.Cell>
      {row.estadoEnvio === EstadosEnvioAsientos.ENVIADO ? (
        <>ENVIADO</>
      ) : (
        <Form.Checkbox
          id={`checkbox-${row._id}`}
          name={`checkbox-${row._id}`}
          disabled={isSubmitting}
          checked={checked}
          onChange={onChange}
        />
      )}
    </Table.Cell>
  )
}

export default React.memo(CheckboxCell)
